"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Row = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Box = require("../Box/Box");

var _Theme = require("../../Theme/Theme.media");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
} // Helper Functions


var buildFlexFlow = function buildFlexFlow(isRow, wrap, reverse) {
  return "".concat(isRow ? 'row' : 'column').concat(reverse ? '-reverse' : '', " ").concat(wrap ? 'wrap' : '');
};

var modifyProps = function modifyProps(props) {
  var full = props.full,
      fullXs = props.fullXs,
      fullSm = props.fullSm,
      fullMd = props.fullMd,
      fullLg = props.fullLg,
      fullXl = props.fullXl,
      flexWrap = props.flexWrap,
      flexReverse = props.flexReverse,
      flexReverseXs = props.flexReverseXs,
      flexReverseSm = props.flexReverseSm,
      flexReverseMd = props.flexReverseMd,
      flexReverseLg = props.flexReverseLg,
      flexReverseXl = props.flexReverseXl;
  return _objectSpread({}, props, {
    flexFlow: full ? buildFlexFlow(false, flexWrap, flexReverse) : buildFlexFlow(true, flexWrap, flexReverse),
    flexFlowXs: fullXs ? buildFlexFlow(false, flexWrap, flexReverse || flexReverseXs && _Theme.media.xs) : buildFlexFlow(true, flexWrap, flexReverse || flexReverseXs && _Theme.media.xs),
    flexFlowSm: fullSm ? buildFlexFlow(false, flexWrap, flexReverse || flexReverseSm && _Theme.media.sm) : buildFlexFlow(true, flexWrap, flexReverse || flexReverseSm && _Theme.media.sm),
    flexFlowMd: fullMd ? buildFlexFlow(false, flexWrap, flexReverse || flexReverseMd && _Theme.media.md) : buildFlexFlow(true, flexWrap, flexReverse || flexReverseMd && _Theme.media.md),
    flexFlowLg: fullLg ? buildFlexFlow(false, flexWrap, flexReverse || flexReverseLg && _Theme.media.lg) : buildFlexFlow(true, flexWrap, flexReverse || flexReverseLg && _Theme.media.lg),
    flexFlowXl: fullXl ? buildFlexFlow(false, flexWrap, flexReverse || flexReverseXl && _Theme.media.xl) : buildFlexFlow(true, flexWrap, flexReverse || flexReverseXl && _Theme.media.xl)
  });
}; // The Component


var Row = function Row(props) {
  return _react.default.createElement(_Box.Box, _extends({}, modifyProps(props), {
    extendsFrom: "row"
  }));
};

exports.Row = Row;
Row.displayName = 'Row';
Row.propTypes = _objectSpread({}, _Box.Box.propTypes, {
  // full
  full: _propTypes.default.bool,
  fullXs: _propTypes.default.bool,
  fullSm: _propTypes.default.bool,
  fullMd: _propTypes.default.bool,
  fullLg: _propTypes.default.bool,
  fullXl: _propTypes.default.bool,
  // flex wrap
  flexWrap: _propTypes.default.bool,
  flexReverse: _propTypes.default.bool,
  flexReverseXs: _propTypes.default.bool,
  flexReverseSm: _propTypes.default.bool,
  flexReverseMd: _propTypes.default.bool,
  flexReverseLg: _propTypes.default.bool,
  flexReverseXl: _propTypes.default.bool,
  // flex
  flex: _propTypes.default.string
});
Row.defaultProps = _objectSpread({}, _Box.Box.defaultProps, {
  // display
  display: 'flex',
  // full
  full: false,
  fullXs: false,
  fullSm: false,
  fullMd: false,
  fullLg: false,
  fullXl: false,
  // flex wrap
  flexWrap: false,
  flexReverse: false,
  flexReverseXs: false,
  flexReverseSm: false,
  flexReverseMd: false,
  flexReverseLg: false,
  flexReverseXl: false,
  // flex
  flex: 'initial'
});